import * as React from "react";

import classnames from "classnames";
import { DropzoneOptions, useDropzone } from "react-dropzone";

type Props = {
  readonly onDrop: DropzoneOptions["onDrop"];
  // Similar to https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types
  readonly acceptedTypes: {
    [mimeType: string]: string[];
  };
  readonly text: React.ReactNode;
  readonly className?: string;
  readonly disabled?: boolean;
  readonly dataTestId?: string;
};

const Dropzone = ({
  onDrop,
  acceptedTypes,
  text,
  className,
  disabled,
  dataTestId = "dropzone-input",
}: Props) => {
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    onDrop,
    accept: acceptedTypes,
    multiple: false,
    disabled,
  });

  return (
    <button
      type="button"
      {...getRootProps()}
      className={classnames(className, {
        dropzone: true,
        "dropzone-active": isDragActive && !isDragReject,
        "dropzone-valid": isDragAccept,
        "dropzone-invalid": isDragReject,
        "dropzone-disabled": disabled,
      })}
    >
      <input {...getInputProps()} data-testid={dataTestId} />
      {text}
    </button>
  );
};

export default Dropzone;
